<template>
  <div class="table-wrapper">
    <div class="table-scroll-container">
      <table class="table align-items-center justify-content-center mb-0">
        <thead class="sticky-header">
          <tr>
            <th v-for="column in columns" :key="column.key" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
              {{ column.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-if="data.length > 0">
            <tr v-for="row in data" :key="row.id">
              <td v-for="column in columns" :key="column.key">
                <template v-if="$slots[column.key]">
                  <slot :name="column.key" :row="row" />
                </template>
                <template v-else>
                  <span class="text-xs font-weight-bold">{{ row[column.key] }}</span>
                </template>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td :colspan="columns.length">
                <div class="empty-state">
                  <div class="empty-state-content">
                    <i class="fas fa-database empty-state-icon"></i>
                    <p class="empty-state-text">No data available</p>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
      default: () => [] 
    },
    columns: {
      type: Array,
      required: true,
      default: () => [] 
    }
  }
};
</script>

<style scoped>
tbody tr:hover {
  background-color: rgba(0,0,0,0.02);
}

.table-wrapper {
  overflow-x: auto;
}

.table-wrapper {
  position: relative;
  height: calc(100vh - 340px);
  min-height: 150px;
  background: white;
}

.table-scroll-container {
  height: 100%;
  overflow-y: auto;
  overflow-x: auto;
}

.sticky-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background: white;
}

.sticky-header tr {
  background: white;
}

.sticky-header th {
  position: sticky;
  top: 0;
  background: white;
  border-bottom: 2px solid #f0f0f0;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.table {
  width: 100%;
  margin-bottom: 0;
  border-collapse: separate;
  border-spacing: 0;
}

td, th {
  white-space: nowrap;
  padding: 12px 8px;
}

td {
  background: white;
}


.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 580px;
}

.empty-state-content {
  text-align: center;
}

.empty-state-icon {
  font-size: 3rem;
  color: #ccc;
  margin-bottom: 1rem;
}

.empty-state-text {
  color: #666;
  font-size: 1rem;
}
</style>